import React from 'react'
import CreatableSelect from 'react-select/creatable';
const components = {
    DropdownIndicator: null,
  };

  const createOption = (label) => ({
    label,
    value: label,
  });

const CustomSelectFilter=({columnValue})=> {
    const processData = columnValue.map(value=>{
        return createOption(value)
    })
    const [inputValue, setInputValue] = React.useState('');
    const [value, setValue] = React.useState(processData);
    const handleKeyDown = (event) => {
        if (!inputValue) return;
        switch (event.key) {
          case 'Enter':
          case 'Tab':
            setValue((prev) => [...prev, createOption(inputValue)]);
            setInputValue('');
            event.preventDefault();
        }
      };
  return (
    <CreatableSelect
      components={components}
      inputValue={inputValue}
      isClearable
      isMulti
      menuIsOpen={false}
      onChange={(newValue) => setValue(newValue)}
      onInputChange={(newValue) => setInputValue(newValue)}
      onKeyDown={handleKeyDown}
      placeholder="Column values"
      value={value}
    />
  )
}

export default CustomSelectFilter;
